var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendP4S3Box1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8988 49.2433C24.8316 52.1286 23.3771 53.5821 20.5296 55.0951C17.6821 56.6081 9.92825 55.0101 11.5536 53.3856C13.7334 51.2059 15.0103 50.4012 14.5787 47.6906C14.0281 44.233 18.5529 41.8974 18.5529 41.8974C18.5529 41.8974 20.5306 40.8189 22.513 41.0909C24.6682 41.3855 27.188 45.7659 27.188 45.7659L25.8988 49.2433Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.086,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3084 34.8032C36.652 40.9572 31.5255 44.6547 28.3201 46.7098L21.1055 39.4612C23.1644 36.2548 26.859 31.1359 32.9989 24.4936C37.5039 19.6203 42.2204 15.1304 46.0341 12.7372C48.8145 10.9919 52.2646 11.2525 54.4075 13.3955C56.5505 15.5375 56.8111 18.9885 55.0658 21.7689C52.6716 25.5816 48.1817 30.2991 43.3084 34.8032Z",
    fill: "#92D3F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3219 33.5371L34.0438 42.26L28.534 46.1842L21.6641 39.2567L25.3219 33.5371Z",
    fill: "#61B2E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5527 41.8979C18.5527 41.8979 14.0288 44.2335 14.5775 47.6901C15.0101 50.4016 13.7332 51.2063 11.5534 53.3861C9.92898 55.0105 17.6819 56.6076 20.5294 55.0955C23.3769 53.5835 24.8304 52.13 25.8986 49.2437M25.9071 33.2977L34.5384 41.929M43.3094 34.8032C36.653 40.9572 31.5265 44.6547 28.3211 46.7098L21.1065 39.4612C23.1654 36.2548 26.86 31.1359 32.9999 24.4936C37.5049 19.6203 42.2214 15.1304 46.0351 12.7372C48.8155 10.9919 52.2656 11.2525 54.4085 13.3955C56.5515 15.5375 56.8121 18.9885 55.0668 21.7689C52.6726 25.5816 48.1828 30.2991 43.3094 34.8032Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendP4S3Box1);
export default __webpack_public_path__ + "static/media/Trend_P4_S3_Box1.481660bfde664aa1df2eec6613d4fa36.svg";
export { ForwardRef as ReactComponent };